import 'slick-carousel/slick/slick.min'

$('.gallery').slick({
	adaptiveHeight: false,
	arrows: true,
	autoplaySpeed: 6000,
	dots: true,
	infinite: false,
	slidesToShow: 1,
	speed: 500,
})

/**
 * Hero Carousel
 */
$('.hero-carousel').slick({
	adaptiveHeight: true,
	arrows: true,
	autoplaySpeed: 6000,
	dots: true,
	infinite: true,
	slidesToShow: 1,
	speed: 500,
	autoplay: true,
	responsive: [
		{
			breakpoint: 650,
			settings: {
				arrows: false,
			},
		},
	],
})

/**
 * Resources
 *
 * @link http://kenwheeler.github.io/slick/
 */
$('.responsive').slick({
	arrows: true,
	autoplaySpeed: 6000,
	dots: false,
	slide: '.slide',
	slidesToShow: 3,
	responsive: [
		{
			breakpoint: 1250,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				centerMode: true,
				autoplay: true,
			},
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				centerMode: true,
				autoplay: true,
			},
		},
		{
			breakpoint: 540,
			settings: {
				arrows: false,
				centerMode: true,
				slidesToShow: 1,
				autoplay: true,
			},
		},
	],
})

$('.timeline-responsive').slick({
	slide: '.timeline-slide',
	slidesToShow: 2,
	slidesToScroll: 1,
	dots: false,
	autoplay: false,
	speed: 1100,
	arrows: true,
	responsive: [
		{
			breakpoint: 1250,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				centerMode: true,
				autoplay: true,
			},
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				centerMode: true,
				autoplay: true,
			},
		},
		{
			breakpoint: 540,
			settings: {
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
			},
		},
	],
})

$('.podcast-episodes-carousel').slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	dots: false,
	autoplay: false,
	speed: 1100,
	arrows: true,
	swipeToSlide: true,
	infinite: false,
	responsive: [
		{
			breakpoint: 1250,
			settings: {
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 540,
			settings: {
				slidesToShow: 1,
			},
		},
	],
})
